import { Injectable, inject } from '@angular/core';

import { TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';
import { WINDOW } from '@frontend/vanilla/core';

import { ModularConfigAccessorService } from '../../widget/core/modular-config-accessor.service';

@Injectable()
export class ItemTreeTrackingService {
    constructor(
        private trackingService: TrackingService,
        private accessorService: ModularConfigAccessorService,
    ) {}

    trackEsportGoToPage(urlClicked: string, sportName: string): void {
        const currentPage = this.accessorService.getPage();
        this.trackingService.track(trackingConstants.EVENT_TRACKING, {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: `${currentPage} widget`,
            [trackingConstants.COMPONENT_LABEL_EVENT]: 'sport events',
            [trackingConstants.COMPONENT_ACTION_EVENT]: 'click',
            [trackingConstants.COMPONENT_POSITION_EVENT]: sportName,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: this.#window.location.href,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: 'go to page',
            [trackingConstants.COMPONENT_URL_CLICKED]: urlClicked,
        });
    }

    trackTreeItemClick(urlClicked: string, eventName: string, isCurrentlyExpanded: boolean): void {
        const currentPage = this.accessorService.getPage();
        this.trackingService.track(trackingConstants.EVENT_TRACKING, {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: `${currentPage} widget`,
            [trackingConstants.COMPONENT_LABEL_EVENT]: 'sport events',
            [trackingConstants.COMPONENT_ACTION_EVENT]: isCurrentlyExpanded ? 'collapse' : 'expand',
            [trackingConstants.COMPONENT_POSITION_EVENT]: currentPage,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: this.#window.location.href,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: eventName,
            [trackingConstants.COMPONENT_URL_CLICKED]: urlClicked,
        });
    }

    readonly #window = inject(WINDOW);
}
